import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row, Form, FormGroup, Label, Input, Modal, ModalBody, Container } from 'reactstrap';
import './CreditLimit.css';
import previewMeetingHistory from '../images/previewMeetingHistory.png';
import previewOrderHistory from '../images/previewOrderHistory.png';
import Storage from '../services/Storage';
import { CommonButton } from './CommonComponents';
import { Roles } from '../constants/Roles';
import closeImg from '../assets/img/close.png';
import CustomSpinner from './CustomSpinner/CustomSpinner';
import ModalService from '../services/ModalService';
import { API_CONSTANTS } from '../constants/api-constant';
import { nullValueFormatArr } from '../utils/utils';

const CreditLimit = ({
  showButtons,
  toggle,
  isShowEntireApp,
  isShowDocuments,
  isShowCompetition,
  isShowCommitment,
  notProposedCreditLimit,
  isPrinting,
  handleDocuments,
  handleCompetition,
  handleCommitment,
  handleEnteireApp,
  handleOrderHistory,
  handleMeetingHistory,
  previewData,
  activeOwner,
  creditOutstandingBalance,
  ageingData,
}) => {
  const navigate = useNavigate();
  const param = useLocation();
  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';

  const [isLoading, setIsLoading] = useState(false);

  let uniqueRemark =
    previewData.updated_credit_limit_remarks &&
      (previewData.updated_credit_limit_remarks !== null ||
        previewData.updated_credit_limit_remarks !== 'undefined')
      ? previewData.updated_credit_limit_remarks.filter(
        (text, index) =>
          index ===
          previewData.updated_credit_limit_remarks.findIndex(
            (other) =>
              text.remark === other.remark &&
              text.action_by === other.action_by &&
              text.role === other.role
          )
      )
      : [];

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    // Reset dates when modal is closed
    if (isModalOpen) {
      setStartDate('');
      setEndDate('');
    }
  };

  const handleSubmit = () => {
    function convertDate(dateStr) {
      // Expects input in "YYYY-MM-DD" format
      const parts = dateStr.split("-");
      if (parts.length !== 3) {
        throw new Error("Invalid date format. Expected 'YYYY-MM-DD'.");
      }
      const [year, month, day] = parts;
      return `${day}.${month}.${year}`;
    }

 
    const token = localStorage.getItem('token');
    const tokenObject = JSON.parse(token);
    const { accessToken } = tokenObject;

 
    setIsLoading(true);
    const payload = {
      customer: previewData.dealer_code,
      start_date: startDate ? convertDate(startDate) : "",
      end_date: endDate ? convertDate(endDate) : "",
      dealer_id: previewData.id,
    };

 
    // Call the API
    fetch(API_CONSTANTS.GENERATE_PDF_WITH_SAP_DATA, {
      method: 'POST',
      headers: {
          "Authorization": "Bearer " + accessToken,
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(async (data) => {
        setIsLoading(false);
        window.open(data.data.url, '_blank')
      })
      .catch(error => {
        setIsLoading(false);
        ModalService.openAlert('', error.message || 'Error occured while generating PDF', 'error');
      });
  };


  const setBreadcrumbsRecord = () => {
    if (previewData.business_name) {
      Storage.setBreadcrumbsrRecord([
        {
          title: 'Preview App',
          url: param.pathname,
        },
        {
          title: previewData.business_name,
          url: `/pages/new-dealer/${previewData.id}`,
        },
      ]);
    }
  };

  const getAgeingArr = () => {
    if (!ageingData) return [];

    return Object.entries(ageingData).map(([key, value]) => {
      if (key.toLowerCase().includes('onwards')) {
        const [num, text] = key.split('_');
        // Format as "731 Days Onwards" (capitalize first letters)
        const formattedText = text
          .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capitals
          .replace(/^./, match => match.toUpperCase()); // Capitalize first letter
        return {
          label: `${parseInt(num)} ${formattedText}`,
          value
        };
      }

      const [prefix, suffix] = key.split('_');
      // Extract numbers from both parts
      const start = parseInt(prefix.replace(/\D/g, ''), 10);
      const end = parseInt(suffix.replace(/\D/g, ''), 10);
      // Get the base text (e.g. "Days" from "030Days")
      const text = suffix.replace(/\d+/g, '');

      return {
        label: `${start} to ${end} ${text}`,
        value
      };
    });
  };

  return (
    <div className='credit-limit' id='creditLimit'>
      <Row>
        <Col xs={12}>
          <div className='creditBlock'>
            <div className='d-flex flex-wrap align-items-center'>
              <div className='main-title'>
                Credit Limit & Risk Measure Tag
                {param &&
                  !param.pathname.includes('pages/approve-application-by-sh') &&
                  roleName &&
                  (roleName === Roles.TM_NAME ||
                    roleName === Roles.SH_NAME ||
                    roleName === Roles.BH_NAME ||
                    roleName === Roles.NH_NAME) ? (
                  <i
                    onClick={() => {
                      setBreadcrumbsRecord();
                      navigate(
                        `/pages/credit-limit-n-risk-measure-tag/${previewData.id}`
                      );
                    }}
                    className='fa fa-edit editIcon noprint'
                  ></i>
                ) : (
                  ''
                )}
                {param &&
                  param.pathname.includes('pages/approve-application-by-sh') ? (
                  <i
                    onClick={toggle}
                    className='fa fa-edit editIcon noprint'
                  ></i>
                ) : (
                  ''
                )}
              </div>
            </div>
            <Row>
              <Col lg={3} md={6} className='order-lg-0 order-md-0 border-right'>
                <div className='creditValBlock'>
                  {previewData.credit_limit && (
                    <div className='subTitle d-flex flex-wrap align-items-center'>
                      <div>
                        {isPrinting || notProposedCreditLimit
                          ? 'Credit Limit'
                          : 'Proposed Credit Limit'}
                      </div>
                      <div className='value'>{previewData.credit_limit}</div>
                    </div>
                  )}
                  {uniqueRemark.length > 0 &&
                    uniqueRemark
                      .slice(0)
                      .reverse()
                      .map((val, index) => {
                        return (
                          <div
                            className='subTitle d-flex flex-wrap align-items-center'
                            key={index}
                          >
                            <div>
                              {val.role === Roles.TM_NAME
                                ? 'Remarks from NH'
                                : val.role === Roles.SH_NAME
                                  ? 'Remarks from SH'
                                  : ''}
                            </div>
                            <div className='value'>{val.remark}</div>
                          </div>
                        );
                      })}
                  {previewData.credit_limit_remarks && (
                    <div className='subTitle d-flex flex-wrap align-items-center'>
                      <div>Remarks</div>
                      <div className='value'>
                        {previewData.credit_limit_remarks}
                      </div>
                    </div>
                  )}
                  {previewData.risk_measure_tag && (
                    <div className='creditValBlock'>
                      <div className='subTitle d-flex flex-wrap align-items-center'>
                        <div>
                          {isPrinting || notProposedCreditLimit
                            ? 'Risk Measure Tag'
                            : 'Proposed Risk Measure Tag'}
                        </div>
                        <div className='value'>
                          {previewData.risk_measure_tag}
                        </div>
                      </div>
                    </div>
                  )}
                  {previewData.expected_business_cash &&
                    previewData.expected_business_credit && (
                      <div className='creditValBlock'>
                        <div className='subTitle d-flex flex-wrap'>
                          <div>
                            {isPrinting || notProposedCreditLimit
                              ? 'Cash Credit Ratio'
                              : 'Proposed Cash Credit Ratio'}
                          </div>
                          <div>
                            <div className='value'>
                              {previewData.expected_business_cash}% &nbsp;&nbsp;
                              <span style={{ color: '#545CD8' }}>/</span>
                              &nbsp;&nbsp; {previewData.expected_business_credit}%
                            </div>
                            <div className='valTitle'>
                              Cash &nbsp;&nbsp;&nbsp; Credit
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </Col>
              <Col lg={3} md={6} className='order-lg-0 order-md-0 border-right'>
                <div className='creditValBlock'>
                  <div className='subTitle title1 d-flex flex-wrap align-items-center'>
                    <div className='border-bottom'>
                      Showing data from the SAP
                    </div>
                  </div>
                </div>
                <div className='creditValBlock'>
                  <div className='subTitle d-flex flex-wrap align-items-center'>
                    <div>
                      Credit Limit
                    </div>
                    <div className='value'>{nullValueFormatArr.includes(creditOutstandingBalance.CustCreditLimit) ? "-" : creditOutstandingBalance.CustCreditLimit}</div>
                  </div>
                </div>
                <div className='creditValBlock'>
                  {previewData.credit_limit && (
                    <div className='subTitle d-flex flex-wrap align-items-center'>
                      <div>
                        {isPrinting || notProposedCreditLimit
                          ? 'Outstanding Balance'
                          : 'Current Outstanding Amount'}
                      </div>
                      <div className='value'>{nullValueFormatArr.includes(creditOutstandingBalance.TotalOsbal) ? "-" : creditOutstandingBalance.TotalOsbal}</div>
                    </div>
                  )}

                  {/* <div
                    className='subTitle d-flex flex-wrap align-items-center'
                  >
                    <div>
                      Credit Limit Utilization
                    </div>
                    <div className='value'>{creditOutstandingBalance.CreditLimitUti ?? "-"}</div>
                  </div> */}
                  <div
                    className='subTitle d-flex flex-wrap align-items-center'
                  >
                    <div>
                      Security Deposit
                    </div>
                    <div className='value'>{nullValueFormatArr.includes(creditOutstandingBalance.SecurityDeposit) ? "-" : creditOutstandingBalance.SecurityDeposit}</div>
                  </div>

                </div>
              </Col>
              <Col lg={5} md={6} className='order-lg-0 order-md-0 border-right'>
                <div className='creditValBlock'>
                  <div className='subTitle d-flex flex-wrap align-items-center'>
                    <div className='border-bottom'>
                      Ageing Report ( Days-Balance)
                    </div>
                    <div className='value'></div>
                  </div>
                  <Container className="d-flex flex-wrap gap-3 justify-content-start">
                    {getAgeingArr().length > 0 ? (
                      getAgeingArr().map((item, index) => (
                        <div
                          key={index}
                          className="border px-3 py-2 text-center bg-light rounded flex-shrink-0"
                          style={{ width: "150px" }}
                        >
                          <div className="fw-bold">{item.label}</div>
                          <div>{nullValueFormatArr.includes(item.value) ? "-" : item.value}</div>
                        </div>
                      ))
                    ) : (
                      <div className='value'>Not getting data from the SAP. Please try again.</div>
                    )}
                  </Container>
                </div>
              </Col>
              {previewData &&
                showButtons &&
                (param.pathname.includes('dealer-list') ||
                  param.pathname.includes('meeting-history') ||
                  param.pathname.includes('open-meeting')) ? (
                <Col lg={1} md={6} className='noprint order-lg-2 order-md-1' >
                  <div className='creditValBlock mt-4 mt-md-3'>
                    <div className='subTitle d-flex flex-wrap' style={{ gap: '15px' }}>
                      {!param.pathname.includes('meeting-history/mtd') ? (
                        <div className='text-center cursorPointer' onClick={() => handleMeetingHistory()}>
                          <img
                            src={previewMeetingHistory}
                            alt='previewMeetingHistory'
                            className='historyIcon'
                            style={{ marginTop: '4px' }}
                          />
                          <div
                            className='valTitle'
                            style={{ paddingTop: '4px' }}

                          >
                            Meeting History
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      {!param.pathname.includes('order-summary/mtd') ? (
                        <>
                          <div onClick={() => handleOrderHistory()} className='text-center'>
                            <img
                              src={previewOrderHistory}
                              alt='previewOrderHistory'
                              className='historyIcon'
                            />
                            <div
                              className='valTitle'
                            >
                              Order Summary
                            </div>
                          </div>

                        </>
                      ) : (
                        ''
                      )}

                      <div onClick={toggleModal} className='text-center cursorPointer' >
                        <img
                          src={previewOrderHistory}
                          alt='accountLedger'
                          className='historyIcon'
                        />
                        <div
                          className='valTitle'
                        >
                          Account Ledger
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ) : (
                ''
              )}
            </Row>
          </div>
        </Col>
        <Col xs={12} className='noprint mb-1 ml-1'>
          <div className='d-flex pt-1 flex-wrap align-items-center buttonBlock'>
            {showButtons && (
              <>
                <CommonButton name={'Dealer Profile'} btnClass={isShowEntireApp && isShowEntireApp ? 'btnPrimary' : 'btnTernary'} type="button" onClick={(e) => {
                  handleEnteireApp(e);
                }} />
                <CommonButton name={'Business Commitment'} btnClass={isShowCommitment && isShowCommitment ? 'btnPrimary' : 'btnTernary'} maxWidth='175px' type="button" onClick={(e) => {
                  handleCommitment(e);
                }} />
                <CommonButton name={'Competition Insights'} btnClass={isShowCompetition && isShowCompetition ? 'btnPrimary' : 'btnTernary'} maxWidth='175px' type="button" onClick={(e) => {
                  handleCompetition(e);
                }} />
                <CommonButton name={'Advance Business Info'} btnClass={isShowDocuments && isShowDocuments ? 'btnPrimary' : 'btnTernary'} maxWidth='175px' type="button" onClick={(e) => {
                  handleDocuments(e);
                }} />
              </>
            )}
          </div>
        </Col>
      </Row>

      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        size="md"
        centered
      >
        <ModalBody>
          {isLoading && <CustomSpinner />}
          <Container>
            <Row>
              <Col xs={12}>
                <div className='modalHeading'>
                  <div className='title leftTitle'>Account Ledger</div>
                  <div className='closeButton'>
                    <img
                      src={closeImg}
                      alt='close'
                      onClick={toggleModal}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} className="d-flex justify-content-center">
                <div className='creditValBlock'>
                  <div className='subTitle d-flex flex-wrap align-items-center' style={{ width: 'min-content' }}>
                    <div style={{ fontWeight: 'bold' }}>Select Statement Duration</div>
                    <Form className='d-flex dateSelect w-100 mt-2'>
                      <FormGroup className='d-flex flex-wrap align-items-center mr-3 mb-0'>
                        <Label for='startDate' className='formLabel mr-2 mb-0'>
                          Start Date
                        </Label>
                        <Input
                          bsSize='sm'
                          type='date'
                          name='startDate'
                          id='startDate'
                          className='dashboardInput mb-0'
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          onKeyDown={(e) => e.preventDefault()}
                          min={endDate ? new Date(new Date(endDate).setMonth(new Date(endDate).getMonth() - 6)).toISOString().split('T')[0] : undefined}
                          max={endDate}
                          style={{ width: '150px' }}
                        />
                      </FormGroup>
                      <FormGroup className='d-flex flex-wrap align-items-center mb-0'>
                        <Label for='endDate' className='formLabel mr-2 mb-0'>
                          End Date
                        </Label>
                        <Input
                          bsSize='sm'
                          type='date'
                          name='endDate'
                          id='endDate'
                          className='dashboardInput mb-0'
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          onKeyDown={(e) => e.preventDefault()}
                          min={startDate}
                          max={startDate ? new Date(new Date(startDate).setMonth(new Date(startDate).getMonth() + 6)).toISOString().split('T')[0] : undefined}
                          style={{ width: '150px' }}
                        />
                      </FormGroup>
                    </Form>
                    <span className='text-muted text-sm'>You can download statement for 6 Month. This data fetching from SAP.</span>

                    <CommonButton
                      name={'Submit'}
                      btnClass='btnPrimary mb-2 mt-3 mx-auto'
                      type="button"
                      onClick={handleSubmit}
                      disabled={!startDate || !endDate}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default React.memo(CreditLimit);
